/**
 * Wall clock corrected by the server offset learned from sync responses (architecture §5.2 "Clock skew").
 * Every timer computation goes through here so two devices agree on the same countdown.
 */
let offsetMs = 0;
export const setServerOffset = (ms: number) => { offsetMs = ms; };
export const serverOffset = () => offsetMs;
export const clockNow = () => new Date(Date.now() + offsetMs);
